<template>
  <div :class="[
      'widget-block',
      componentClass,
      ]">
    <!--Widget Header-->
    <div
    v-if="widgetInfo.widgetName !== 'import-users'"
    class="row no-gutters py-2 px-3 text-white rounded-top bg-ltblue">
      <!--Widget Name-->
      <div class="col-6 d-inline-block widget-title">
        {{ widgetInfo.widgetTitle }}
      </div>
      <!--Widget Link-->
      <div v-if="widgetInfo.route" class="col-6 d-inline-block text-right smaller-font-content">
        <router-link :to="{ name: widgetInfo.route }" class="align-middle text-white">
          <span>{{ widgetInfo.linkTitle }}</span><i class="fas fa-angle-right ml-1"></i>
        </router-link>
      </div>
    </div>

    <importusers-block v-if="widgetInfo.widgetName === 'import-users'" :widgetInfo="widgetInfo"></importusers-block>

    <uploadusers-block v-if="widgetInfo.widgetName === 'upload-users'" :widgetInfo="widgetInfo" class="px-3 my-2"></uploadusers-block>

    <downloadfile-block v-if="widgetInfo.widgetName === 'download-file'" :widgetInfo="widgetInfo" class="px-3 my-2"></downloadfile-block>

    <div class="widget-loader">
      <div v-show="isLoading" class="loader-content text-center">
        <i class="fas fa-circle-o-notch fa-spin mr-1"></i>Loading&hellip;
      </div>
    </div>
  </div>
</template>

<script>
import ImportusersBlock from '@/components/presentational/ImportusersBlock';
import DownloadfileBlock from '@/components/presentational/DownloadfileBlock';
import UploadusersBlock from '@/components/presentational/UploadusersBlock';

export default {
  props: ['widgetInfo'],
  data() {
    return {
      isLoading: false,
    };
  },
  components: {
    ImportusersBlock,
    DownloadfileBlock,
    UploadusersBlock,
  },
  computed: {
    componentClass() {
      return `${this.widgetInfo.widgetName}-block`;
    },
  },
};
</script>

<style scoped>
label {
  margin-bottom: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
}

/**WIDGET STYLING**/
.card.no-padding,
.card.no-padding .card-body {
  padding: 0 !important;
}

/**DATE RANGE FILTER TABS**/
.widget-block .tabs .btn-group {
  width: 100%;
}
  .widget-block .tabs .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
  .widget-block .tabs .btn-group > .btn-group:not(:last-child) > .btn {
    border-radius: 0;
  }
    .widget-block .tabs .btn-group label {
      margin-bottom: 1rem;
    }
      .widget-block .tabs label.btn {
        padding: 0.25rem 0.5rem 0.375rem;
        color: #3674B2;
        text-transform: capitalize;
        border: none;
      }
        .widget-block .tabs label.btn.active {
          color: #FFFFFF;
          background: #3674B2;
          border-radius: 0 0 0.25rem 0.25rem !important;
        }
          .widget-block .tabs label.btn.active:first-child {
            border-radius: 0 0 0.25rem 0 !important;
          }
          .widget-block .tabs label.btn.active:last-child {
            border-radius: 0 0 0 0.25rem !important;
          }

.widget-block {
  overflow-x: hidden;
}

/**WIDGET LOADING ANIMATION**/
.widget-loader .loader-content{
  position: absolute;
  top: 37%;
  left: 0;
  right: 0;
  max-width: 150px;
  min-width: 150px;
  padding: 0.5rem;
  margin: auto;
  color: #3674B2;
  background:rgba(255,255,255, 0.8);
  border-radius: 0.25rem;
}

/**WIDGET ICONS**/
.card .widget-title::before {
  margin-right: 0.25rem;
  font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
  font-weight: 600;
  color: #FFFFFF;
}

/**IMPORT USERS**/
/**IMPORT USER TITLE ICONS**/
.upload-users-block .widget-title::before {
  content: "\F574";
}
.download-file-block .widget-title::before {
  content: "\F56D";
}

.widget-block.import-users-block {
  overflow: visible !important;
}
</style>
<style>
i.fa-circle-o-notch:before{
  content: "\f1ce";
  font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
  color: #3674B2;
}
</style>



// WEBPACK FOOTER //
// src/components/presentational/widgets/BlockWidget.vue?39a9a944